export default __webpack_public_path__ + "images/ed54ed924a885caf1bb4d2030fba795a-google.png";